export default function Card() {
  return {}
}
